(() => {
  const related = document.querySelector('[data-nuoma-related]');
  const grid = related?.querySelector('[data-related-grid]');
  if (!related || !grid || !window.fetch) return;
  const recommendationUrl = related.dataset.recommendationsUrl;
  const productId = related.dataset.productId;
  if (!recommendationUrl || !productId) return;

  const root = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'EUR';
  let formatPrice;
  try {
    formatPrice = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency', currency
    });
  } catch (_) { return; }

  function productCard(item) {
    if (!item.handle || !item.featured_image) return null;
    const card = document.createElement('article');
    card.className = 'product-card';
    const media = document.createElement('a');
    media.className = 'product-card__media';
    const url = root + 'products/' + encodeURIComponent(item.handle);
    media.href = url;
    media.setAttribute('aria-label', item.title);
    const image = document.createElement('img');
    image.src = typeof item.featured_image === 'string'
      ? item.featured_image : item.featured_image.src;
    if (!image.src) return null;
    image.alt = item.title;
    image.loading = 'lazy';
    image.width = 620;
    image.height = 680;
    media.append(image);
    if (item.available === false) {
      const badge = document.createElement('span');
      badge.className = 'badge';
      badge.textContent = 'Indisponible';
      media.append(badge);
    }
    const info = document.createElement('div');
    info.className = 'product-card__info';
    const text = document.createElement('div');
    const heading = document.createElement('h3');
    const titleLink = document.createElement('a');
    titleLink.href = url;
    titleLink.textContent = item.title;
    heading.append(titleLink);
    text.append(heading);
    const pricing = document.createElement('div');
    pricing.className = 'price';
    const p = Number(item.price_min ?? item.price);
    if (!Number.isFinite(p)) return null;
    const price = document.createElement('span');
    price.textContent = (item.price_varies ? 'À partir de ' : '') + formatPrice.format(p / 100);
    pricing.append(price);
    info.append(text, pricing);
    card.append(media, info);
    return card;
  }

  let url;
  try { url = new URL(recommendationUrl, window.location.href); } catch (_) { return; }
  url.searchParams.set('product_id', productId);
  const limit = Math.min(8, Math.max(2, Number.parseInt(related.dataset.limit || '4', 10) || 4));
  url.searchParams.set('limit', String(limit));
  url.searchParams.set('intent', 'related');
  fetch(url.toString(), {headers: {'Accept': 'application/json'}})
    .then(response => {
      if (!response.ok) throw new Error('Recommendations unavailable');
      return response.json();
    })
    .then(data => {
      if (!Array.isArray(data.products)) return;
      const ids = new Set();
      const cards = [];
      for (const item of data.products) {
        if (cards.length >= limit) break;
        if (!item || String(item.id) === String(productId) || ids.has(item.id)) continue;
        const card = productCard(item);
        if (!card) continue;
        cards.push(card);
        ids.add(item.id);
      }
      // A single recommendation must not replace a complete product selection.
      if (cards.length >= Math.min(3, limit)) grid.replaceChildren(...cards);
    })
    .catch(() => { /* Keep Shopify Liquid recommendations visible. */ });
})();
